import React from "react";
import styled from "styled-components";

import RoomIntro from "./room-intro";
import ImportIntro from "./import-intro";
import PlaylistIntro from "./playlist-intro";
import MiniModeIntro from "./mini-mode-intro";
import { Col, Row, Text } from "../../comps";
import { Theme } from "../../theme/theme-provider";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  padding: 0px 5%;
  align-items: center;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb:hover {
  }
`;

const Head = styled(Row)`
  width: 100%;
  margin-top: 20px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
`;

export default () => {
  return (
    <Wrapper>
      <Text
        width="90%"
        marginTop="20px"
        fontFamily={Theme.fontFamily.recursive}
        fontSize="42px"
        fontWeight={600}
        color={Theme.color.BLUE_5}
        textAlign="center"
      >{`AVC-COLLAB : Listen Together`}</Text>
      <Text
        width="90%"
        marginTop="0px"
        fontWeight={550}
        fontFamily={Theme.fontFamily.grenze}
        fontSize="32px"
        color={Theme.color.GRAY_0}
        textAlign="center"
      >{`Collab lets you play & listen to music in sync with friends or public rooms`}</Text>
      <RoomIntro />
      <ImportIntro />
      <PlaylistIntro />
      <MiniModeIntro />
      <div style={{ marginTop: "30px" }} />
    </Wrapper>
  );
};

//Amq-qlqbjYA
